import { useCallback, useState } from 'react';
import { AssetTypeForm, AssetTypes } from '../../../type';
import { createNewAssetTypes, deleteAssetTypes, editNewAssetTypes } from 'services/asset';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { useFlash } from 'contexts/flash';
import { AssetTypeProps } from './index';
export const useInjection = ({
  initSearchText,
  refreshDataAssetTypes,
  onExport
}: Partial<AssetTypeProps>) => {
  const { setFlash } = useFlash();
  const [searchText, setSearchText] = useState<string>(initSearchText || '');
  const [showModalAddNew, setShowModalAddNew] = useState<boolean>(false);
  const [typeEdit, setTypeEdit] = useState<AssetTypes | undefined>(undefined);
  const [idDelete, setIdDelete] = useState<number | undefined>(undefined);

  const onCloseModalAdd = () => {
    setShowModalAddNew(false);
  };

  const listButton = [
    {
      text: 'Export Spreadsheet',
      type: 'primary',
      onClick: () => {
        if (onExport) onExport('xlsx');
      }
    },
    {
      text: 'Export PDF',
      type: 'secondary',
      onClick: () => {
        if (onExport) onExport('pdf');
      }
    },
    {
      text: 'Add New Asset Type',
      type: 'primary',
      onClick: () => setShowModalAddNew(true)
    }
  ];
  const handleAddTypes = useCallback(
    async (value: AssetTypeForm) => {
      const convertPayload = {
        name: value.name,
        fields: value.fields?.map((item) => ({
          name: item.name,
          unit: item.unit,
          category: item.category,
          dropdownOptionId: item.dropdownOptionId,
          defaultValue: item.inputType === 'TEXT' ? item.defaultValue : undefined,
          defaultDropdownValueId:
            item.inputType === 'DROPDOWN' ? item.defaultDropdownValueId : undefined
        }))
      };

      await createNewAssetTypes(convertPayload);
      setFlash({ type: 'success', message: 'Create asset type successfully' });
      refreshDataAssetTypes && refreshDataAssetTypes();
      onCloseModalAdd();
    },
    [refreshDataAssetTypes, setFlash]
  );

  const { asyncCallback: asyncAddNewType } = useAsyncCallback(handleAddTypes, []);
  const handleEditTypes = useCallback(
    async (value: AssetTypeForm) => {
      if (!typeEdit) return;
      const convertPayload = {
        name: value.name,
        fields: value.fields?.map((item) => ({
          name: item.name,
          unit: item.unit,
          category: item.category,
          dropdownOptionId: item.dropdownOptionId,
          id: Number(item.fieldId) || undefined,
          isDelete: item.isDelete,
          deleteDropdownId: item.deleteDropdownId,
          defaultValue: item.inputType === 'TEXT' ? item.defaultValue : undefined,
          defaultDropdownValueId:
            item.inputType === 'DROPDOWN' ? item.defaultDropdownValueId : undefined
        }))
      };
      await editNewAssetTypes(Number(typeEdit.id), convertPayload);
      setFlash({ type: 'success', message: 'Update asset type successfully' });
      refreshDataAssetTypes && refreshDataAssetTypes();
      setTypeEdit(undefined);
    },
    [refreshDataAssetTypes, setFlash, typeEdit]
  );

  const { asyncCallback: asyncEditType } = useAsyncCallback(handleEditTypes, []);

  const handleDelete = useCallback(async () => {
    if (!idDelete) return;
    setIdDelete(undefined);
    await deleteAssetTypes(idDelete);
    setFlash({ type: 'success', message: 'Delete asset type successfully' });
    refreshDataAssetTypes && refreshDataAssetTypes();
  }, [idDelete, setFlash, refreshDataAssetTypes]);

  const { asyncCallback: asyncDeleter } = useAsyncCallback(handleDelete, []);

  return {
    searchText,
    setSearchText,
    listButton,
    showModalAddNew,
    setShowModalAddNew,
    asyncAddNewType,
    asyncEditType,
    typeEdit,
    setTypeEdit,
    asyncDeleter,
    onCloseModalAdd,
    idDelete,
    setIdDelete
  };
};
